import { FormInput } from "components/BaseForm";
import { REQUIRED_MARK } from "components/BaseForm/fields/fieldClasses";
import { Card, CardContent, CardHeader, CardTitle } from "components/ui/card";
import { FieldDescription, FieldLegend, FieldSet } from "components/ui/field";
import { BandSwatch } from "routes/settings/global/BandSwatch";

const DISTANCE_BANDS = [
  { name: "distance_limit_min", label: "Green", color: "green" },
  { name: "distance_limit_mid", label: "Yellow", color: "yellow" },
  { name: "distance_limit_max", label: "Red", color: "red" },
];

export function PiracyCard() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Piracy</CardTitle>
      </CardHeader>
      <CardContent className="tw:flex tw:flex-col tw:gap-5">
        <div className="tw:sm:max-w-60">
          <FormInput
            name="piracy.time_limit"
            label="Recent Event Time Limit"
            type="number"
            min={0}
            suffix="months"
            required
          />
        </div>
        <FieldSet>
          <FieldLegend variant="label" className={REQUIRED_MARK}>
            Nearby Event Distance Limits
          </FieldLegend>
          <FieldDescription>
            Distances in meters. Each band must be larger than the one before
            it.
          </FieldDescription>
          <div className="tw:grid tw:grid-cols-1 tw:gap-5 tw:sm:grid-cols-3">
            {DISTANCE_BANDS.map(band => (
              <FormInput
                key={band.name}
                name={`piracy.${band.name}`}
                label={band.label}
                type="number"
                min={0}
                prefix={<BandSwatch color={band.color} />}
                suffix="m"
              />
            ))}
          </div>
        </FieldSet>
      </CardContent>
    </Card>
  );
}
